import NotificationsTable from "components/notifications/NotificationsTable";
import InfoContext from "pages/InfoContext";
import { useContext, useMemo, useState, useEffect } from "react";
import { useAlertsContext } from "api/alerts/AlertsProvider";
import PageContext from "pages/PageContext";
import { tabletSize } from "utils/screenSizes";
import { QUERY_STATUS } from "constants/constants";

const Notifications = () => {
  const {
    getNotifications,
    getUnreadNotifications,
    updateNotifications,
    deleteNotifications,
    setNotifications,
    notifications,
    loadNotificationsStatus,
    unreadNotifications,
    unreadNotificationsCount,
  } = useAlertsContext();

  const { lang, userScope, connectedUser } = useContext(PageContext);

  const [searchValue, setSearchValue] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [isArchivedSection, setIsArchivedSection] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [isNotificationDetail, setIsNotificationDetail] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState({});
  const [isSelectAllNotificationsChecked, setIsSelectAllNotificationsChecked] =
    useState(false);
  const [checkedNotificationsIds, setCheckedNotificationsIds] = useState([]);

  const {
    items_per_page: notificationsPerPage,
    content: notificationsContent,
    page: notificationsPage,
    total_items: notificationsTotalItems,
    total_pages: notificationsTotalPages,
  } = notifications;

  useEffect(() => {
    setNotifications({});
    getUnreadNotifications();
  }, []);

  useEffect(() => {
    getNotifications({
      lang: lang === "fr" ? "Fr" : "En",
      limit: 50,
      archived: isArchivedSection,
    });
  }, [lang, isArchivedSection]);

  const loadMoreResults = () => {
    const loadMoreCondition = notificationsPage < notificationsTotalPages;
    if (loadNotificationsStatus !== QUERY_STATUS.LOADING && loadMoreCondition) {
      getNotifications({
        lang: lang === "fr" ? "Fr" : "En",
        page: notificationsPage + 1,
        archived: isArchivedSection,
        limit: 50,
      });
    }
  };

  const values = useMemo(
    () => ({
      isTablet: tabletSize,
      notifications,
      updateNotifications,
      deleteNotifications,
      lang,
      userScope,
      connectedUser,
      setNotifications,
      filteredResults,
      setFilteredResults,
      loadNotificationsStatus,
      unreadNotifications,
      notificationsContent,
      notificationsTotalItems,
      isArchivedSection,
      setIsArchivedSection,
      isSearch,
      setIsSearch,
      isNotificationDetail,
      setIsNotificationDetail,
      selectedNotification,
      setSelectedNotification,
      isSelectAllNotificationsChecked,
      setIsSelectAllNotificationsChecked,
      checkedNotificationsIds,
      setCheckedNotificationsIds,
      unreadNotificationsCount,
      notificationsPerPage,
    }),
    [
      notifications,
      updateNotifications,
      deleteNotifications,
      lang,
      connectedUser,
      setNotifications,
      filteredResults,
      setFilteredResults,
      loadNotificationsStatus,
      unreadNotifications,
      userScope,
      notificationsContent,
      notificationsTotalItems,
      isArchivedSection,
      setIsArchivedSection,
      isSearch,
      setIsSearch,
      isNotificationDetail,
      setIsNotificationDetail,
      selectedNotification,
      setSelectedNotification,
      isSelectAllNotificationsChecked,
      setIsSelectAllNotificationsChecked,
      checkedNotificationsIds,
      setCheckedNotificationsIds,
      unreadNotificationsCount,
      notificationsPerPage,
    ]
  );
  return (
    <InfoContext.Provider value={values}>
      <NotificationsTable
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        loadMoreResults={loadMoreResults}
      />
    </InfoContext.Provider>
  );
};

export default Notifications;
